<template>
  <div>
    <AccountContainer />
  </div>
</template>

<script>
import AccountContainer from '@/modules/account'
export default {
  name: 'account',
  components: {
    AccountContainer,
  },
}
</script>
